import GPOnlyInPremium from "../gp-onlyinpremium.svelte"

export let FMGUpgrade = {

    showOnlyInPremium: function(variant) {
        let v = variant ? variant : "plants";
        let component = new GPOnlyInPremium({
            target: document.body,
            props: {
                variant: v,
                activationFromWebsiteAvailable: false
            }});
        component.open();
        component.$on('upgrade', () => {
            window.open(GPSettings.upgradeURL, '_blank').focus();
        });
    },

};
